import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PsaAuthorizationService {
  private psaFunctions: any[] = [];

  setFunctions(functions: any[]): void {
    this.psaFunctions = functions ?? [];
  }

  getFunctions(): any[] {
    return this.psaFunctions;
  }

  clearFunctions(): void {
    this.psaFunctions = [];
  }
}
